import { render } from "./customization_component.vue?vue&type=template&id=a3d00d68&scoped=true"
import script from "./customization_component.vue?vue&type=script&lang=js"
export * from "./customization_component.vue?vue&type=script&lang=js"

import "./customization_component.vue?vue&type=style&index=0&id=a3d00d68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d00d68"]])

export default __exports__